import { Modal } from "antd";
import React, { useState } from "react";
import ReactCodeInput from "react-code-input";
import "./confirmStyle.scss";

const OtpModal = (props: any) => {
  const { visible, setVisible, handleConfirmOTP, phoneNumber } = props;
  const [otp, setOtp] = useState("");

  return (
    <Modal
      width={400}
      className="confirm-otp"
      title="Xác nhận"
      visible={visible}
      cancelText="Đóng"
      onCancel={() => setVisible(false)}
      okText="Xác nhận"
      onOk={() => handleConfirmOTP(otp)}>
      <label>
        Quý khách vui lòng nhập mã xác thực được gửi về số điện thoại{" "}
        <span className="confirm-otp__phone-number">{phoneNumber}</span>
      </label>

      <div className="confirm-otp__input">
        <ReactCodeInput
          name=""
          inputMode="latin-name"
          type="number"
          fields={6}
          onChange={(e) => {
            setOtp(e);
          }}
        />
      </div>
    </Modal>
  );
};

export default OtpModal;
